<template>
    <div class="betslip__system-combinations">
        <input
            v-model="isSelected"
            :id="system.toString()"
            type="checkbox"
            class="checkbox"
            v-bind="$attrs"
        >
        <label :for="system.toString()">
            <span class="form-check-label__text">{{ label }}</span>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'SystemCheckbox',
        props: {
            system: {
                type: Object,
                required: true
            },
            label: {
                type: String,
                required: true
            },
        },
        computed: {
            isSelected: {
                get() {
                    return this.system.isSelected;
                },
                set() {
                    this.$emit('systemClick', this.system);
                }
            }
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/SystemCheckbox.vue